import React from 'react';
import { useDispatch } from 'react-redux';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import PropTypes from 'prop-types';

import iconSet from '../../../shared/images/teambuildr-selection.json';
import Text from '../../../shared/components/Text/Text';
import { setOrderingInfoModalOpen } from '../ducks/calendarActions';

const ModalContentWrapper = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const ModalTitle = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
`;

const CloseIcon = styled('div')`
display: none;
position: absolute;
top: -15px;
right: -10px;
cursor: pointer;
transition: all 250ms ease-in-out;
:hover {
    opacity: 0.7;
}
`;

const ItemsUseLegacyOrderInfoModal = ({ closeModal }) => {
  const dispatch = useDispatch();

  return (
    <ModalContentWrapper>
      <CloseIcon onClick={closeModal}>
        <IcomoonReact iconSet={iconSet} icon='remove' size={14} color='#9E9E9E' />
      </CloseIcon>
      <ModalTitle>
        <Text fontSize='24px' fontWeight='600'>Items Use Legacy Order</Text>
      </ModalTitle>
      <Text>
        {' '}
        The ordering system here is using the legacy order, because of this
        you may experience a higher instance of workout scrambling.
        The new ordering system alleviates this.
      </Text>
      <Text style={{ marginTop: '10px', cursor: 'pointer', color: '#4A90E2' }} onClick={() => dispatch(setOrderingInfoModalOpen(true))}>Click here to learn more about the new reordering functionality</Text>
    </ModalContentWrapper>
  );
};

ItemsUseLegacyOrderInfoModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  modalData: PropTypes.shape({
    weekViewDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    isFromWeekView: PropTypes.bool,
  }),
};

ItemsUseLegacyOrderInfoModal.defaultProps = {
  modalData: null,
};

export default ItemsUseLegacyOrderInfoModal;
